/**
 * Whether a product-nav item should render as active for a pathname.
 *
 * Extracted from BugZeroSidebar's isItemActive so the rule is testable. Two
 * special cases, both pre-existing behaviour plus one addition:
 *
 *  - `/prevent` is an exact match (its dashboard must not light up on
 *    /prevent/vendors).
 *  - `exclude` (STRY0038480) lets a broad prefix step aside for a more
 *    specific sibling: Projects matches `/plan` so it stays lit on
 *    `/plan/:projectId`, but must not also light up on `/plan/reports`.
 *
 * Platform nav items are matched by id, not by path, and never reach here.
 */
export function navItemMatches(pathname, item) {
  if (!item || !item.match) return false;
  if (item.match === '/prevent') return pathname === '/prevent';
  if (item.exclude && item.exclude.some(p => pathname.startsWith(p))) return false;
  return pathname.startsWith(item.match);
}

export default navItemMatches;
